import z from "zod";
import { fingerprintDataSchema } from "../dtos/fingerprint-data";
import { baseEntitySchema } from "./base";
import { DealCategory } from "./deal";
import { StatusTierSchema } from "../dtos/status-tier";
import { DiscountType } from "./promo-code";
import { ProductType } from "./product";

export const temporaryDealPromoCodeSchema = z.object({
  id: z.string(),
  code: z.string(),
  name: z.string(),
  discount: z.union([
    z.number(),
    z.object({
      type: z.nativeEnum(DiscountType),
      value: z.number(),
    }),
  ]),
  enabledFor: z.nativeEnum(ProductType).optional(),
  expirationDate: z.date().optional(),
});

export const temporaryDealDataSchema = z.object({
  category: z.nativeEnum(DealCategory),
  name: z.string(),
  customerId: z.string(),
  productId: z.string().optional(),
  productName: z.string(),
  quantity: z.number(),
  amount: z.number().min(1),
  buyOrSell: z.string(),
  type: z.string(),
  stage: z.number(),
  unitPrice: z.number(),
  businessLostReason: z.string().optional(),
  accountEmail: z.string().optional(),
  accountPassword: z.string().optional(),
  paymentMethod: z.string().optional(),
  paymentDetails: z.string().optional(),
  paypalEmail: z.string().optional(),
  fingerprints: z.array(fingerprintDataSchema),
  statusTier: StatusTierSchema.optional(),
  promoCode: temporaryDealPromoCodeSchema.optional(),
  archived: z.boolean().default(false),
  /**
   * Set on quotes staff create in the admin portal. Their offer link stays
   * open until this date instead of the 10 minutes a website quote gets.
   */
  expiresAt: z.date().optional(),
  /**
   * Per-mile rate staff set on an admin quote, used instead of the product's
   * price tiers whenever the quote is re-priced.
   */
  unitPriceOverride: z.number().positive().optional(),
  /**
   * "admin" for quotes staff created in the admin portal. Their miles and
   * price are fixed, so the offer can't be adjusted.
   */
  source: z.enum(["website", "admin"]).optional(),
});

export type TemporaryDealData = z.infer<typeof temporaryDealDataSchema>;
export const temporaryDealSchema = baseEntitySchema.merge(
  temporaryDealDataSchema,
);
export type TemporaryDeal = z.infer<typeof temporaryDealSchema>;
